import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { SingleImageFactory } from '../../factories/SingleImageFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class SingleImage extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new SingleImageFactory
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes', 'containerClasses']
  }

  elementContents() {
    return ['alt', 'srcType', 'srcSize', 'src', 'clickAction', 'clickTarget', 'srcLink', 'link']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }

  info() {
    return {
      name: 'SingleImage',
      icon: 'fa-image',
      variations: this.variationsInfo()
    }
  }
}